import React, { useState } from 'react';
import SectionTitle from '../ui/SectionTitle';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './ContactInfo.css';

const ContactInfo = () => {
    const [sectionRef, isSectionVisible] = useScrollAnimation(0.1);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [status, setStatus] = useState({
        submitting: false,
        submitted: false,
        error: null
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        setStatus({ submitting: true, submitted: false, error: null });

        try {
            const response = await fetch('http://localhost:5000/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                setStatus({ submitting: false, submitted: true, error: null });
                setFormData({ name: '', email: '', message: '' });

                setTimeout(() => {
                    setStatus(prev => ({...prev, submitted: false }));
                }, 5000);
            } else {
                setStatus({
                    submitting: false,
                    submitted: false,
                    error: data.error || 'Something went wrong. Please try again.'
                });
            }
        } catch (error) {
            setStatus({
                submitting: false,
                submitted: false,
                error: 'Network error. Please check your connection.'
            });
        }
    };

    return ( <
        section className = "contact-section"
        ref = { sectionRef } >
        <
        div className = "container" >
        <
        div className = { `animate-on-scroll ${isSectionVisible ? 'visible' : ''}` } >
        <
        SectionTitle subtitle = "CONTACT"
        title = "Get in Touch" /
        >
        <
        p className = "contact-subtitle" >
        Ready to streamline your operations ? Contact us today. <
        /p> <
        /div>

        <
        div className = { `contact-form-container scale-on-scroll ${isSectionVisible ? 'visible' : ''}` } >
        <
        h2 className = "form-title" > Contact Us < /h2> <
        p className = "form-subtitle" > Please fill in the information below. < /p>

        {
            status.submitted && ( <
                div className = "form-success" >
                Thank you
                for your message!We 'll get back to you soon. <
                /div>
            )
        }

        {
            status.error && ( <
                div className = "form-error" > { status.error } <
                /div>
            )
        }

        <
        form className = "contact-form"
        onSubmit = { handleSubmit } >
        <
        div className = "form-group" >
        <
        label htmlFor = "name" > Name < /label> <
        input type = "text"
        id = "name"
        name = "name"
        placeholder = "Your Name.."
        className = "form-input"
        value = { formData.name }
        onChange = { handleChange }
        required disabled = { status.submitting }
        /> <
        /div>

        <
        div className = "form-group" >
        <
        label htmlFor = "email" > Email < /label> <
        input type = "email"
        id = "email"
        name = "email"
        placeholder = "Your Email.."
        className = "form-input"
        value = { formData.email }
        onChange = { handleChange }
        required disabled = { status.submitting }
        /> <
        /div>

        <
        div className = "form-group" >
        <
        label htmlFor = "message" > Message < /label> <
        textarea id = "message"
        name = "message"
        placeholder = "Your Message.."
        className = "form-textarea"
        rows = "5"
        value = { formData.message }
        onChange = { handleChange }
        required disabled = { status.submitting } >
        < /textarea> <
        /div>

        <
        button type = "submit"
        className = "form-submit"
        disabled = { status.submitting } >
        { status.submitting ? 'Sending...' : 'Submit' } <
        /button> <
        /form> <
        /div> <
        /div> <
        /section>
    );
};

export default ContactInfo;